import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gold-500/20">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-serif font-bold text-gold-400 mb-2">ROYAL HOOKA</h3>
            <p className="text-gray-300 text-sm">
              Experience the finest hookah lounge with premium flavors and luxurious ambiance.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="text-lg font-semibold text-gold-400 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-gold-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-gold-400 transition-colors">About</Link></li>
              <li><Link to="/menu" className="text-gray-300 hover:text-gold-400 transition-colors">Menu</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-gold-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-right">
            <h4 className="text-lg font-semibold text-gold-400 mb-4">Contact</h4>
            <p className="text-gray-300 text-sm mb-2">123 Luxury Street</p>
            <p className="text-gray-300 text-sm mb-2">Downtown City, DC 12345</p>
            <p className="text-gray-300 text-sm">Phone: (555) 123-4567</p>
          </div>
        </div>

        <div className="border-t border-gold-500/20 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>&copy; {currentYear} Royal Hooka Lounge. All rights reserved.</p>
            <p>
              Domain + Hosting + Design = {' '}
              <a 
                href="https://account4web.ca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gold-400 hover:text-gold-300 transition-colors"
              >
                Account4Web Inc
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;